import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

const STATUS_OPTIONS = [
  { display: 'Complete', status: 'COMPLETED', textClass: 'alert-confirmation' },
  { display: 'Failed', status: 'FAILED', textClass: 'active-dm' },
  {
    display: 'Message Sent',
    status: 'MESSAGE_SENT',
    textClass: 'warning-yellow',
  },
  {
    display: 'Running',
    status: 'RUNNING',
    textClass: 'warning-yellow',
  },
  { display: 'Pending', status: 'PENDING', textClass: 'text-dark' },
];
const DISPLAY_MAP = new Map([
  ['COMPLETED', 'Complete'],
  ['FAILED', 'Failed'],
  ['MESSAGE_SENT', 'Message Sent'],
  ['RUNNING', 'Running'],
  ['PENDING', 'Pending'],
]);

export default function CommandStatusSelectDropdown({
  selectedStatus,
  handleStatusSelect,
  mobileView,
}) {
  return (
    <div className={`dropdown ${mobileView ? 'border rounded' : ''}`}>
      <button
        className={`btn btn-link dropdown-toggle text-decoration-none text-text-light-gray d-flex align-items-center justify-content-between ${
          mobileView ? 'p-1 w-100' : 'p-0'
        }`}
        type="button"
        id="statusSelectMenuButton"
        data-toggle="dropdown"
        aria-haspopup="true"
        aria-expanded="false"
      >
        <span className="text-capitalize three-quarter-text">
          {DISPLAY_MAP.get(selectedStatus) || 'Status'}
        </span>
      </button>
      <div
        className={`dropdown-menu rounded-lg ${mobileView ? 'w-100' : ''}`}
        aria-labelledby="statusSelectMenuButton"
        style={{ minWidth: 'unset' }}
      >
        {STATUS_OPTIONS.filter(({ status }) => status !== selectedStatus).map(
          ({ status, display, textClass }) => (
            <button
              key={status}
              className={`dropdown-item px-3 text-decoration-none three-quarter-text text-${textClass}`}
              onClick={() => handleStatusSelect(status, mobileView)}
            >
              {display}
            </button>
          )
        )}
        {selectedStatus ? (
          <button
            className={`dropdown-item px-3 pt-3 text-decoration-none three-quarter-text text-dark`}
            onClick={() => handleStatusSelect('', mobileView)}
          >
            <FontAwesomeIcon icon={faTimes} size="xs" className="mr-2" />
            View All
          </button>
        ) : null}
      </div>
      <style jsx>{`
        .dropdown-toggle::after {
          margin-left: 4rem;
        }
        .dropdown-item {
          outline: none;
        }
        .dropdown-item:hover {
          background: transparent;
        }
      `}</style>
    </div>
  );
}

CommandStatusSelectDropdown.propTypes = {
  selectedStatus: PropTypes.oneOf(
    STATUS_OPTIONS.map(({ status }) => status).concat('')
  ),
  handleStatusSelect: PropTypes.func,
  mobileView: PropTypes.bool,
};
